<template>
  <div class="client-guide">
    <el-tabs type="card">
      <el-tab-pane label="Content">
        <div class="guide-html" v-html="generateMarkedHtml(guides.content.content)"></div>
      </el-tab-pane>
      <el-tab-pane label="Players">
        <div class="guide-html" v-html="generateMarkedHtml(guides.content.players)"></div>
      </el-tab-pane>
      <el-tab-pane label="Audio">
        <div class="guide-html" v-html="generateMarkedHtml(guides.content.audio)"></div>
      </el-tab-pane>
      <el-tab-pane label="Integrate">
        <div class="guide-html" v-html="generateMarkedHtml(guides.content.integrate)"></div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { reactive } from 'vue'
import marked from 'marked'
export default {
  name: 'ClientGuide',
  data () {
    const flagLoading = reactive({
      retrieve: false
    })
    return {
      guides: { type: '', content: { content: '' } },
      flagLoading
    }
  },
  created () {
    this.getSettings()
  },
  methods: {
    getSettings: function () {
      if (this.flagLoading.retrieve) return
      this.flagLoading.retrieve = true
      const url = '/api/v1/atk_player/settings/guide'
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.guides = res.data
        } else {
          console.error('getSettings', res.msg)
        }
        that.flagLoading.retrieve = false
      }).catch(function (err) {
        console.error('getSettings', err.msg)
        that.flagLoading.retrieve = false
      })
    },
    generateMarkedHtml: function (content) {
      return marked(content || '')
    }
  }
}
</script>
